export type InflationType = 'compound' | 'simple' | 'none';

/**
 * Policy figures captured per client to power the Genworth policy-education slides.
 * In production these would come from the carrier API; for the MVP an advisor enters
 * them by hand and they're persisted to localStorage, scoped to a single client id.
 */
export interface GenworthPolicyDetails {
  monthlyPremium?: number;
  benefitPool?: number;
  dailyBenefitMax?: number;
  monthlyBenefitMax?: number;
  inflationType?: InflationType;
  inflationRate?: number;
  waitingPeriodDays?: number;
  isPartnership?: boolean;
  originalPremium?: number;
}

const storageKey = (clientId: string) => `genworthPolicyDetails_${clientId}`;

export function loadPolicyDetails(clientId: string): GenworthPolicyDetails {
  try {
    const raw = localStorage.getItem(storageKey(clientId));
    return raw ? (JSON.parse(raw) as GenworthPolicyDetails) : {};
  } catch {
    return {};
  }
}

export function savePolicyDetails(clientId: string, details: GenworthPolicyDetails): void {
  try {
    localStorage.setItem(storageKey(clientId), JSON.stringify(details));
  } catch {
    // localStorage may be unavailable (private mode, quota); fail silently for this MVP helper.
  }
}
